module.exports = __webpack_public_path__ + "static/media/Damaged.269ea304.svg";